import CompanyListView from "@/views/admin/companies/CompanyListView";
import CompanyCreateView from "@/views/admin/companies/CompanyCreateView";
import CompanyEditView from "@/views/admin/companies/CompanyEditView";

export default [
  {
    name: "pages.admin.companies",
    path: "companies",
    component: CompanyListView
  },
  {
    name: "pages.admin.companies.create",
    path: "companies/create",
    component: CompanyCreateView
  },
  {
    name: "pages.admin.companies.edit",
    path: "companies/:id/edit",
    component: CompanyEditView
  }
];
